import React from "react";
import { useIntl } from "react-intl";
import ChartTypeIcon from "../ChartTypeIcon";
import {
  CHART_TYPE_AREA,
  CHART_TYPE_CANDLES,
  CHART_TYPE_BARS,
  CHART_TYPE_HEIKIN_ASHI,
} from "../../../constants";

const TILE_ICON_SIZE = 34;

const CHART_TYPES = [
  {
    id: CHART_TYPE_AREA,
    labelKey: "futures.chart.type.line",
  },
  {
    id: CHART_TYPE_CANDLES,
    labelKey: "futures.chart.type.candles",
  },
  {
    id: CHART_TYPE_BARS,
    labelKey: "futures.chart.type.bars",
  },
  {
    id: CHART_TYPE_HEIKIN_ASHI,
    labelKey: "futures.chart.type.heikin_ashi",
  },
];

/**
 * Grid of 4 chart-type tiles.
 *
 * @param {object} props
 * @param {number}   props.activeType - current SeriesType value
 * @param {Function} props.onSelect   - (type: number) => void
 */
const ChartTypeTiles = ({ activeType, onSelect }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  return (
    <div className="chart-type-menu__types-grid">
      {CHART_TYPES.map((item) => (
        <button
          key={item.id}
          type="button"
          className={`chart-type-menu__type-tile${activeType === item.id ? " chart-type-menu__type-tile--active" : ""}`}
          onClick={() => onSelect(item.id)}
          aria-pressed={activeType === item.id}
        >
          <span className="chart-type-menu__type-icon"><ChartTypeIcon type={item.id} size={TILE_ICON_SIZE} /></span>
          <span className="chart-type-menu__type-label">{t(item.labelKey)}</span>
        </button>
      ))}
    </div>
  );
};

export default ChartTypeTiles;
